<div class="container my-3">
    <div [formGroup]="needsForm">
        <!-- Protection -->
        <div>
            <mat-checkbox color="primary" formControlName="protection">
                1. {{ "survey.new.needs-fis.protection" | translate }}
            </mat-checkbox>
        </div>

        <!-- Savings -->
        <div>
            <mat-checkbox color="primary" formControlName="savings" (change)="onSavingsChange($event)">
                2. {{ "survey.new.needs-fis.savings" | translate }}
            </mat-checkbox>
        </div>
        <div *ngIf="savings?.value" class="ms-4">
            <mat-checkbox color="primary" class="d-block" formControlName="savingsInvestment">{{ "survey.new.needs-fis.savings-investment" | translate }}</mat-checkbox>
            <mat-checkbox color="primary" class="d-block" formControlName="savingsPlan">{{ "survey.new.needs-fis.savings-plan" | translate }}</mat-checkbox>
        </div>

        <!-- Previdence -->
        <div>
            <mat-checkbox color="primary" formControlName="previdence">
                3. {{ "survey.new.needs-fis.previdence" | translate }}
            </mat-checkbox>
        </div>

        <!-- SUBMIT -->
        <button *ngIf="isInsert()" class="btn btn-primary mt-3 next-step" [disabled]="completed" (click)="onSubmit()">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            {{ 'survey.new.needs-fis.next' | translate }}
        </button>
    </div>
</div>
